export const DEFAULT_THEME_LOADER = {
  logo: "/assets/images/logo/agridence.svg",
  primary: "var(--ag-blue)",
  secondary: "var(--ag-red)",
};
